import clsx from 'clsx';
import PropTypes from 'prop-types';

function CardsSection({ maxHeight, children }) {
  return (
    <section className="mt-3 container mx-auto h-full flex flex-col justify-center items-center">
      <div
        className={clsx('w-full overflow-y-auto rounded-lg', {
          [maxHeight]: maxHeight,
          'max-h-[62vh]': !maxHeight,
        })}
      >
        <div className="flex flex-col gap-2">
          {/*<AnimatePresence>*/}
          {children}
          {/*</AnimatePresence>*/}
        </div>
      </div>
    </section>
  );
}

CardsSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CardsSection;
